
  function removeDisable() {
    document.querySelectorAll(".has-dpo-disabled")
      .forEach(el => el.classList.remove("has-dpo-disabled"));
  }

  function onDpoObserverReady() {
    removeDisable();
    observeOptionsData();
  }

  if (typeof dpoObserver !== "undefined") {
    onDpoObserverReady();

  }else{

    const observer = new MutationObserver(() => {
      if (typeof dpoObserver !== "undefined") {
        onDpoObserverReady();
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

  }


  function addPreorderLabel(el, value) {

    if (el.hasAttribute("data-label-order-preorder")) {
      const current = el.getAttribute("data-label-order-preorder");
      const newValue = current + "," + value;
      el.setAttribute("data-label-order-preorder", newValue);

    } else {
      el.setAttribute("data-label-order-preorder", value);
    }

  }

  function optionsData() {
    window.dpoOptions.options.forEach(options => {

      const optionContainerElId = document.querySelector(`#dynamic_option_id_${options.option_id}`);

      options.items.forEach(option => {

        const optionElText = optionContainerElId.querySelector(`[product-sku="${option.product_sku}"][value="${option.option_type_id}"]`);
        
        if (option.stock_actual !== undefined && option.is_salable !== undefined) {

          if (option.is_salable === 1 && option.stock_actual <= 0) {

            if (optionElText.tagName === "INPUT" ) {

              const optionContaier = optionElText.closest('.admin__field-option');

              const span = document.createElement("span");
              span.classList.add("dpo-option-preorder-badge");
              span.textContent = "Pre order";
              optionContaier.appendChild(span);

            }else if(optionElText.tagName === "OPTION"){

              const optionContaier = optionElText.closest('.control');
              const selectOptionLabelContainer = optionContaier.querySelector('.dpo_dd_mask');

              addPreorderLabel(selectOptionLabelContainer, option.order);

            }

          }           
        }

      });

    });
  }

  function optionDropdownClick() {

    const dropdownOptionContainers = document.querySelectorAll('.dpo_dd_mask');

    dropdownOptionContainers.forEach(container => {
      container.addEventListener('click', function() {

        const attr = container.getAttribute('data-label-order-preorder');
        if (attr) {

          const indexes = attr.split(',').map(n => parseInt(n, 10));
          const rows = container.querySelectorAll('table tr');

          indexes.forEach(i => {

            const targetRow = rows[i];

            if (targetRow) {
                const span = document.createElement("span");
                span.classList.add("dpo-option-preorder-badge");
                span.textContent = "Pre order";
                targetRow.appendChild(span);
            }
          });

        }

      });
    });

  }

  function observeOptionsData() {
    
    if (window.dpoOptions?.options) {
      optionsData();
      optionDropdownClick();

    }else{

      const optionsObserver = new MutationObserver(() => {
        if (window.dpoOptions?.options) {
          optionsData();
          optionDropdownClick();
          optionsObserver.disconnect();
        }
      });

      optionsObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

